import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import LinkTableCellComponent from "./common/LinkTableCellComponent";
import Label1 from "./common/Label1";
import ContractStepper from "./contracts/ContractStepper";
import ActionButton3 from "./common/Action Buttons/ActionButton3";
import IconActionButton from "./common/IconActionButton";
import ActionButton4 from "./common/Action Buttons/ActionButton4";

const PageWrapper = styled.div`
  width: 590px ;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  max-height: 100vh;
  flex: 1;
  overflow-y: scroll;
  padding: 40px 44px 100px 44px;
`;

const ContractStepperWrapper = styled.div`
    margin: 40px 0;
`;

const Payments = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 150px);
  grid-auto-flow: row;
  
  grid-column-gap: 50px;
  
  margin: 32px 0;
  
`;

const ContractHeading = styled.div`
    display: grid;
    margin-bottom: 30px;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 24px;
    
    font-style: normal;
    font-family: Metropolis;
    
    .heading {
        font-weight: 500;
        font-size: 24px;
        line-height: 24px;
    }
    
    .sub-heading {
        font-weight: normal;
        font-size: 18px;
        line-height: 18px;
    } 
`;

const CustomDivider = styled.hr`
    border: 1px dashed var(--color-gray-400);
    width: 100%;
`;

const ActionsWrapper = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    height: fit-content;
    
    margin-bottom: 40px;
    
    display: flex;
    flex-direction: row;
    justify-content: start;
    
     > * {
      margin-right: 24px;
    }
    
    padding: 0 40px;
`;


function PaymentInfoSidePanel({payment, contractId, status, onViewContractClick, onSignContractClick, onReadyForDeliveryClick}) {

    return (
        <PageWrapper>
            <ContentWrapper>
                <ContractHeading>
                    <div className="heading">Contract ID: <LinkTableCellComponent name={contractId} onLinkClick={() => {}}/> </div>
                    <div className="sub-heading">Status: {status}</div>
                </ContractHeading>

                <CustomDivider/>

                <Payments>
                    <Label1>Date</Label1>
                    <Label1>Payment Due</Label1>
                    <Label1>Status</Label1>



                </Payments>

                <CustomDivider/>


                <Payments>
                    <Label1>Date</Label1>
                    <Label1>Payment Due</Label1>
                    <Label1>Status</Label1>



                </Payments>


            </ContentWrapper>


            <ActionsWrapper>
                <ActionButton4>
                    View Ammortization Schedule
                </ActionButton4>

                <ActionButton4>
                    View Payment History
                </ActionButton4>
            </ActionsWrapper>
        </PageWrapper>
    );
}

PaymentInfoSidePanel.propTypes = {};
PaymentInfoSidePanel.defaultProps = {};

export default PaymentInfoSidePanel;
